export default "__VITE_ASSET__BEKFs$cI__"